import React, {FC, useState, useCallback, useEffect} from 'react';
import cn from 'classnames';
import {useStoreon} from 'storeon/react';
import {useMediaQuery} from 'react-responsive';
import { GxGrid, GxRow } from '@garpix/garpix-web-components-react';
import { Events, State } from '@/interfaces';
import Sidebar from '../Sidebar';
import Header from '../Header';
import styles from './styles/index.module.scss';
import Content from '../Content';

const Layout: FC = ({ children }) => {
  const isDesktopOrMobile = useMediaQuery({
    query: '(min-width: 568px)'
  })
    const { dispatch, flagSidebar } = useStoreon<State, Events>('flagSidebar')
  const [isOpenSidebar, setisOpenSidebar] = useState(false);
    const toggleVisibleSidebar = () => {
        dispatch('changeSidebar', !flagSidebar);
    }
  const toggleOpenSidebar = useCallback(()=>setisOpenSidebar((prev)=>!prev),[])
    const handleClickSidebar = () => {
        toggleOpenSidebar();
    }
    useEffect(()=>{
        if(!isDesktopOrMobile) toggleVisibleSidebar();
    },[isDesktopOrMobile])

  return (
    <GxGrid>
        {isDesktopOrMobile &&
            <GxRow className={styles['row-header']}>
              <Header isOpenSidebar={isOpenSidebar} toggleVisibleSidebar={toggleVisibleSidebar}/>
            </GxRow>
        }
      <GxRow>
        { (flagSidebar  || (isDesktopOrMobile  && !flagSidebar)) &&
          <div
            className={cn({
              [styles['coll-left__menu']]: true,
              [styles['close']]: !isOpenSidebar,
            })}
          >
            <Sidebar
              isOpenSidebar={isOpenSidebar}
              toggleOpenSidebar={handleClickSidebar}
            />
          </div>
        }
        <div className={cn({
          [styles['coll-right__menu']]: true,
          [styles['coll-right__menu--full']]: !flagSidebar
        })} >
            <Content>{children}</Content>
        </div>
      </GxRow>
    </GxGrid>
  );
};

export default Layout;
